import { Routes } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const authRoutes: Routes = [
  {
    title: 'pagesTitles.login',
    path: APP_ROUTES.LOGIN,
    loadComponent: () =>
      import('./pages/login').then((m) => m.Login),
  },
  {
    title: 'pagesTitles.register',
    path: APP_ROUTES.REGISTER,
    loadComponent: () =>
      import('./pages/register').then((m) => m.Register),
  },
];
